/* unplugin-vue-components disabled */import { render } from "./upload.vue?vue&type=template&id=c865bf68&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"

import "./upload.vue?vue&type=style&index=0&id=c865bf68&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c865bf68"],['__file',"src/components/chat-input-v2/upload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c865bf68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c865bf68', __exports__)) {
    api.reload('c865bf68', __exports__)
  }
  
  module.hot.accept("./upload.vue?vue&type=template&id=c865bf68&scoped=true", () => {
    api.rerender('c865bf68', render)
  })

}


export default __exports__